import { render, staticRenderFns } from "./a-image.vue?vue&type=template&id=5a8597d1"
import script from "./a-image.vue?vue&type=script&lang=js"
export * from "./a-image.vue?vue&type=script&lang=js"
import style0 from "./a-image.vue?vue&type=style&index=0&id=5a8597d1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports